import React from "react";
import LoginRegister from "./LoginRegister";

const Signup = () => {
  return (
    <section className="login-section auth-page">
      <div className="image-layer"></div>
      <div className="outer-box">
        <LoginRegister mode="register" />
      </div>
    </section>
  );
};

export default Signup;
